export const SLUG_VIEW = 'view';
export const VIEW_GRID = 'grid';
export const VIEW_GRID_BIG = 'grid-big';
export const VIEW_LIST = 'list';
export const VIEW_GALLERY = 'gallery';
export const VIEW_GALLERY_SMALL = 'gallery-small';

export const PROD_SLID_BP = {
  991: {
    slidesPerView: 4,
    slidesPerGroup: 1,
  },
  768: {
    slidesPerView: 3,
    slidesPerGroup: 1,
  },
  480: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  320: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
};

export const BESTSEL_SLID_BP = {
  1600: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  1300: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  991: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  768: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  570: {
    slidesPerView: 3,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  480: {
    slidesPerView: 3,
    slidesPerGroup: 1,
    simulateTouch: true,
  },
  320: {
    slidesPerView: 2,
    slidesPerGroup: 1,
    simulateTouch: true,
  },
};

export const SIMILAR_SLID_BP = {
  1600: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  1300: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  991: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  768: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  570: {
    slidesPerView: 3,
    slidesPerGroup: 1,
    simulateTouch: false,
  },
  480: {
    slidesPerView: 3,
    slidesPerGroup: 1,
    simulateTouch: true,
  },
  320: {
    slidesPerView: 2,
    slidesPerGroup: 1,
    simulateTouch: true,
  },
};

export const THUMBS_SLID_BP = {
  1190: {
    slidesPerView: 5,
    slidesPerGroup: 1,
  },
  1099: {
    slidesPerView: 5,
    slidesPerGroup: 1,
  },
  991: {
    slidesPerView: 5,
    slidesPerGroup: 1,
  },
  767: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 3,
  },
  570: {
    slidesPerView: 3,
    slidesPerGroup: 1,
  },

  320: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
};

export const HUGE_GAL_THUMB_SLID_BP = {
  1190: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 3,
  },
  1099: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 3,
  },
  991: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 3,
  },
  760: {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 3,
  },
  570: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    direction: 'horizontal',
  },
  380: {
    direction: 'horizontal',

    slidesPerView: 3,
    slidesPerGroup: 1,
  },
  320: {
    direction: 'horizontal',

    slidesPerView: 2,
    slidesPerGroup: 1,
  },
};

export const BUILT_SLID_BP = {
  1399: {
    slidesPerView: 3,
    slidesPerGroup: 1,
  },
  991: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  768: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  480: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  320: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
};
